module.exports = __webpack_public_path__ + "img/send-out-arrival.2f41affd.svg";